module.exports = __webpack_public_path__ + "static/media/PayPal_small.7f85db54.svg";